// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"10f1507d","795":"57420304","977":"8f20bfba"}[chunkId] + ".chunk.js";
};